import React from 'react';
import { View } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { observer } from 'mobx-react-lite';

import { screens } from './screens';
import { AuthNavigator } from './AuthNavigator';
import { MainNavigator } from './MainNavigator';
import type { SwitchStackParamListType } from './types';
import { useAuthModel } from '@models/AuthModel';

const SwitchStack =
  createNativeStackNavigator<SwitchStackParamListType>();

export const SwitchNavigator = observer(() => {
  const authModel = useAuthModel();

  return (
    <SwitchStack.Navigator
      screenOptions={{
        // since it's switch navigator
        // we render only what we need
        headerShown: false,
        animation: 'none',
      }}
    >
      {authModel.isAuthorized === null && (
        <SwitchStack.Screen component={View} name={screens.Initial} />
      )}

      {authModel.isAuthorized === true && (
        <SwitchStack.Screen
          component={MainNavigator}
          name={screens.MainNavigator}
        />
      )}

      {authModel.isAuthorized === false && (
        <SwitchStack.Screen
          component={AuthNavigator}
          name={screens.AuthNavigator}
        />
      )}
    </SwitchStack.Navigator>
  );
});
